/*
import {
  hf,
  ht,
  useGblz,
  f,
  gs,
} from 'lib';
*/
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as gs from "./_csGbl";
import * as ht from './_ht';
import * as hf from './_hf';

import * as ihd from './ihd';

export const itlI1yz = () => ({
  i1yrz: {},
  i1zrs: [],
}) as ht.dz;

export const crtI1zz = () => {
  const _gUserz = gs.useGblz('user');
  const _i1yz = itlI1yz();
  hf.udtDz(_i1yz.i1yrz, {
    ... ihd.i('i1yr'),
    i1yr_31r1f: _gUserz.crt._31rz?._fst,
  });
  _i1yz.i1zrs = [];
  return _i1yz;
};

export const loadI1yrLsAsync = async ( pz?: {
  i1yrd1100sStt?: ht.s,
  i1yrd1100sEnd?: ht.s,
  i1yrs1100i?: ht.n,
} ) => {
  const _gUserz = gs.useUserz();
  let _cdn = cmFTH.vdd(false);
  _cdn += ` AND i1yr_31r1f = ${_gUserz.crt._31rz?._fst}`;
  _cdn += ` AND i1yra1100i > 0`; // エントリがある日付のみ
  if ( hf.f(pz?.i1yrd1100sStt) ) _cdn += ` AND i1yrd1100s >= '${pz?.i1yrd1100sStt}'`;
  if ( hf.f(pz?.i1yrd1100sEnd) ) _cdn += ` AND i1yrd1100s <= '${pz?.i1yrd1100sEnd}'`;
  if ( pz?.i1yrs1100i && pz?.i1yrs1100i == 999 ) _cdn += ` AND i1yrs1100i >= -1`;
  if ( pz?.i1yrs1100i && pz?.i1yrs1100i != 999 ) _cdn += ` AND i1yrs1100i = ${pz?.i1yrs1100i}`;
  //hf.l(`IcvI1z 107: ${_cdn}, ${hf.s(pz)}`);
  const _ls = await cmFTH.loadLsAsync({
    tgt: 'i1yrs',
    cdn: _cdn,
    fld: '_key as key, i1yrd1100s as pfx, *',
    tailz: {
      odr: 'i1yrd1100s desc',
    }
  })
  return _ls;
};

export const loadI1yrDzAsync = async ( pz: {
  i1yr_key?: ht.n,
  i1yrd1100s?: ht.s,
 } ) => {
  const _gUserz = gs.useGblz('user');
  let _cdn = cmFTH.vdd(false) + ` AND i1yr_31r1f = ${_gUserz.crt._31rz?._fst}`;
  if (pz.i1yr_key) _cdn += ` AND _key = ${pz.i1yr_key}`;
  if (pz.i1yrd1100s) _cdn += ` AND i1yrd1100s = '${pz.i1yrd1100s}'`;

  //hf.l(`IcvI1y___Mz 62: ${_cdn}`);
  const _dz = await cmFTH.loadDzAsync({
    tgt: 'i1yrs',
    cdn: _cdn,
    lwrz: {
      i1zrs: {
        tgt: 'i1zrs',
        cdn: cmFTH.vdd() + ` AND i1zr_31r1f = ${_gUserz.crt._31rz._fst} AND i1zrd3100s = '{i1yrd1100s}' AND i1zrs1200i >= 70`,
        rlcz: {
          i1yrd1100s: 'i1yrs.i1yrd1100s',
        },
        tailz: {
          odr: 'i1zra1200s, i1zra1100s',
        },
        lwrz: {
          i18rs: {
            tgt: 'i18rs',
            cdn: cmFTH.vdd() + ` AND _fst = {i1zri18r1f}`, // i18r は _31r_fst で縛れない
            rlcz: {
              i1zri18r1f: 'i1zrs.i1zri18r1f',
            }
          }
        }
      },
    }
  });
  //hf.l(`IcvI1z 62: ${hf.s(_dz)}`);
  return {
    i1yrz: { ... _dz, cldz: undefined },
    i1zrs: _dz.cldz?.i1zrs ?? [],
  };
};

export const saveI1yrDzAsync = async ( pz: {
  i1yz: ht.dz,
} ) => {
  const _gUserz = gs.useUserz();
  let _cdn = cmFTH.vdd(false);
  _cdn += ` AND i1yr_31r1f = ${_gUserz.crt._31rz._fst}`;
  _cdn += ` AND i1yrd1100s = '${pz.i1yz.i1yrz.i1yrd1100s}'`;
  //hf.l(`IcvI1y___Mz 102: ${hf.s(pz.i1yz.i1yrz)}`);
  //hf.l(`IcvI1y___Mz 103: ${_cdn}`);
  const _ls = await cmFTH.upsDzAsync({
    tgt: 'i1yrs',
    cdn: _cdn,
    dz: {
      ... pz.i1yz.i1yrz,
    },
    atrs:
      undefined,
  });
  //hf.l(`IcvI1z 452: ${_dz}`);
  const _dz2 = {
    i1yrz: hf.f(_ls) ? { ... _ls[0], cldz: undefined } : {},
  };
  return _dz2;
};
